export const MEMBER_APP_DOWNLOAD_URL = 'https://xhmm.app.link/gSclncQPyNb'
export const SHOPPER_APP_DOWNLOAD_URL = 'https://shiptshopper.app.link/3JqhfADPkOb'
export const CIRCLE_MASTERCARD_APPLICATION_URL =
  'https://www.target.com/redcard/credit-card-application'
export const TARGET_BASE_URL = 'https://www.target.com'
